(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("mbc-core"), require("mbc-flag"), require("mbc-legend"));
	else if(typeof define === 'function' && define.amd)
		define(["mbc-core", "mbc-flag", "mbc-legend"], factory);
	else if(typeof exports === 'object')
		exports["mbc-horizontal-bar"] = factory(require("mbc-core"), require("mbc-flag"), require("mbc-legend"));
	else
		root["mbc-horizontal-bar"] = factory(root["mbc-core"], root["mbc-flag"], root["mbc-legend"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_0__, __WEBPACK_EXTERNAL_MODULE_1__, __WEBPACK_EXTERNAL_MODULE_2__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 120);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_0__;

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_1__;

/***/ }),

/***/ 101:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 120:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(21);


/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_2__;

/***/ }),

/***/ 21:
/***/ (function(module, exports, __webpack_require__) {

"use strict";



__webpack_require__(101);

var _horizontalBarChart = __webpack_require__(66);

var _horizontalBarChart2 = _interopRequireDefault(_horizontalBarChart);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = _horizontalBarChart2.default;

/***/ }),

/***/ 63:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Core = __webpack_require__(0);
var Utils = Core.Utils;
var validateData = Utils.object.NaNtoNull;

function DataMethods() {}
/**
* To initialize data and change benchmark visibility if benchmarks present
* @param  {Array} array of json objects containing bar and benchmark data values
*/
DataMethods.prototype.setData = function (obj) {
    if (obj.bars) {
        this.set("barInput", obj.bars);

        // Still update the benchmark when obj.benchmark is null
        this.set("benchMarkInput", obj.benchmarks || []);

        if (obj.benchmarks && obj.benchmarks.length > 0) {
            this.set("benchMarksVisible", true);
        }

        this.setScaleData();
    }

    this.checkBreakpoints();
};
/** To update data values for horizontal bars & benchmarks
* @param {array} array of data objects
*/
DataMethods.prototype.updateData = function (obj) {
    if (obj.bars) {
        this.set("barInput", obj.bars);

        if (obj.benchmarks && obj.benchmarks.length > 0) {
            this.set("benchMarkInput", obj.benchmarks);
            this.set("benchMarksVisible", true);
        }

        this.set("dataChanged", true);
        this.update();
    }
};
/**
* To set the data values for the scales
*/
DataMethods.prototype.setScaleData = function (update) {

    var bars = [],
        benchmarks = [],
        _this = this;
    var allBars = this.get("barInput"),
        allMarks = this.get("benchMarkInput") || [];

    allBars.forEach(function (bar) {
        bars.push(validateData(_this.getSingleBarData(bar)));
    });

    if (allMarks) {
        allMarks.forEach(function (val) {
            benchmarks.push(validateData(_this.getSingleBenchMarkData(val)));
        });
    }

    if (update) {
        this.get("data").update("barData", bars);
        this.get("data").update("benchMarkData", benchmarks);
    } else {
        this.get("data").set("barData", bars);
        this.get("data").set("benchMarkData", benchmarks);
    }

    this.set("dataLength", bars.length);
};
/**
 * To set path to bar data values
 * @param  {Object} obj
 * @return {Number|String|Null|Undefined}  bar data value
 */
DataMethods.prototype.getSingleBarData = function (obj) {
    return obj.value;
};
/**
 * To set path to benchmark data values
 * @param  {Object} obj
 * @return {Number|String|Null|Undefined}  benchmark data value
 */
DataMethods.prototype.getSingleBenchMarkData = function (obj) {
    return obj.value;
};

/**
 * To combine two datasets into one array of objects
 */
DataMethods.prototype.combineData = function (a, b) {

    var result = [];

    for (var i = 0; i < a.length; i++) {

        var container = {};
        container.bar = a[i];

        if (b && b.length > 0) {
            container.benchmark = b[i] || {};
        } else {
            container.benchmark = {};
        }

        result.push(container);
    }

    return result;
};

module.exports = DataMethods;

/***/ }),

/***/ 64:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Core = __webpack_require__(0);
var Utils = Core.Utils;
var useEnDash = Utils.string.convertDashToEnDash;
var ToolTip = __webpack_require__(1);

function ToolTipMixin() {}
/**
 * To configure the tooltip template function;
 * The template outer div must be given the "tooltip-inner" class;
 * The template outer div must also be given the "tooltip-flag" class;
 * The toolTipTemplate method must accept "d" as a parameter;
 * The toolTipTemplate method must return a template string
 * @type {Function}
 */
ToolTipMixin.prototype.toolTipTemplate = function (d) {
    var header;
    var customHeaderPath = this.get("toolTipDynamicHeaderPath");
    var label1 = this.get("toolTipLabel1");
    var label2 = this.get("toolTipLabel2");
    var toolTipTickFormat = this.get("toolTipTickFormat");
    var formatFn = this.tickFormat(toolTipTickFormat);
    var maxWidthTextCell = 164; // 200 max width - 10 icon with - 26 in total padding
    var font = "'MorningstarIntrinsic', 'HelveticaNeue-Bold', 'Helvetica Neue Bold', Helvetica, Arial, sans-serif";
    var size = 16;

    var bar, benchmark;

    if (!toolTipTickFormat || toolTipTickFormat === "none") {
        formatFn = this.tickFormat(this.get("xAxisTickFormat"));
    }

    if (this.get("toolTipUseStaticHeader")) {
        header = this.get("toolTipStaticHeader");
    } else {
        header = d.bar[customHeaderPath];
    }

    if (this.get("benchMarksVisible")) {

        bar = useEnDash(formatFn(d.bar.value));
        benchmark = useEnDash(formatFn(d.benchmark.value));

        var barWidth = Utils.string.getTextWidth(bar, font, size);
        var benchmarkWidth = Utils.string.getTextWidth(benchmark, font, size);
        maxWidthTextCell = barWidth > benchmarkWidth ? maxWidthTextCell - barWidth : maxWidthTextCell - benchmarkWidth;

        return "<div class=\"tooltip-inner tooltip-flag\">\n                <div class=\"tooltip-title\"><p>" + header + "</p></div>\n                <div class=\"tooltip-body tooltip-table\">\n                    <div class=\"cell tooltip-row\">\n                        <div class=\"legend-rect\"></div>\n                        <div class=\"tip-cell-name tooltip-cell\" style=\"max-width: " + maxWidthTextCell + "px\">" + label1 + "</div>\n                        <div class=\"tip-cell-data tooltip-cell\">" + bar + "</div>\n                    </div>\n                    <div class=\"cell tooltip-row\">\n                    <div class=\"benchmark-legend-rect\"></div>\n                        <div class=\"tip-cell-name tooltip-cell\" style=\"max-width: " + maxWidthTextCell + "px\">" + label2 + "</div>\n                        <div class=\"tip-cell-data tooltip-cell\">" + benchmark + "</div>\n                    </div>\n                </div>\n            </div>";
    } else {

        bar = useEnDash(formatFn(d.bar.value));
        maxWidthTextCell = maxWidthTextCell - Utils.string.getTextWidth(bar, font, size);

        return "<div class=\"tooltip-inner tooltip-flag\">\n                <div class=\"tooltip-title\"><p>" + header + "</p></div>\n                <div class=\"tooltip-body\">\n                    <div class=\"cell\">\n                        <div class=\"legend-rect\"></div>\n                        <div class=\"tip-cell-name tooltip-cell\" style=\"max-width: " + maxWidthTextCell + "px\">" + label1 + "</div>\n                        <div class=\"tip-cell-data tooltip-cell\">" + bar + "</div>\n                    </div>\n                </div>\n            </div>";
    }
};
/**
 * To bind the tooltip to the tooltip transparent canvas
 */
ToolTipMixin.prototype.addToolTip = function (options) {

    this.set("showToolTip", true);

    var t = this.toolTipTemplate.bind(this);

    var tooltip = ToolTip(options).template(t),
        canvas = this.get("canvas"),
        layer = canvas.layer("tooltip-canvas-layer", "front"),
        svg = layer.selectAll("rect");

    svg.call(tooltip.bind());

    this.set("tooltipInfo", tooltip);
};
/**
 * To remove the tooltip and tooltip canvas
 */
ToolTipMixin.prototype.removeToolTip = function () {

    this.set("showToolTip", false);

    var canvas = this.get("canvas"),
        layer = canvas.layer("tooltip-canvas-layer");

    layer.remove();

    this.update();
};
/**
 * To render tranparent horizontal bars to serve as tooltip canvas
 */
ToolTipMixin.prototype.drawToolTipCanvas = function () {

    var canvas = this.get("canvas"),
        _this = this,
        layer = canvas.layer("tooltip-canvas-layer", "front"),
        yFormat = this.get("yCoordinateFormat"),
        barHeightFormat = this.get("barHeightFormat"),
        barData = this.get("barInput"),
        bmarkData = this.get("benchMarkInput"),
        barPadding = this.get("barPadding"),
        length = barData.length,
        barSpacing = canvas.height() / length - barPadding / length,
        barHeight = typeof barHeightFormat === "function" ? barHeightFormat(barSpacing - barPadding) : barSpacing - barPadding;
    var toolTipData = this.combineData(barData, bmarkData);

    var bars = layer.selectAll("rect").data(toolTipData);

    bars.enter().append("rect").classed("tooltip-canvas-bars", true).attr("transform", "translate(0,0 )").attr("y", function (d, i) {
        return typeof yFormat === "function" ? yFormat(i * barSpacing + barPadding) : i * barSpacing + barPadding;
    }).attr("height", barHeight).attr("x", 0).attr("width", canvas.width()).on("mouseover", function (d, i) {
        _this.toggleHighlight(i);
    }).on("mouseout", function (d, i) {
        _this.toggleHighlight(i);
    }).on("mousemove", function (d) {
        var obj = {};
        var chartCanvas = canvas.get("svg").select(".mbc-layers").node().getBoundingClientRect();
        obj.tooltip = _this.get("tooltipInfo")._clientRect;
        obj.mouse = d3.mouse(this);
        obj.canvasWidth = chartCanvas.width;
        obj.canvasHeight = chartCanvas.height;
        obj.canvasTop = chartCanvas.top;
        _this.changeToolTipDirection(obj);
        if (_this.get("tooltipHidden")) {
            _this.get("tooltipInfo").show(d, {
                position: _this.get("direction"),
                namespace: _this.get("id")
            });
            _this.set("tooltipHidden", false);
        }
    });

    bars.transition().duration(300).attr("transform", "translate(0,0 )").attr("y", function (d, i) {
        return typeof yFormat === "function" ? yFormat(i * barSpacing + barPadding) : i * barSpacing + barPadding;
    }).attr("height", barHeight).attr("x", 0).attr("width", canvas.width());

    bars.exit().remove();
};
/**
 * To highlight horizontal bars on hover
 * */
ToolTipMixin.prototype.toggleHighlight = function (index) {
    var canvas = this.get("canvas"),
        layer = canvas.layer("bar-chart-layer"),
        bar = layer.selectAll("rect")[0][index];

    if (bar.id === "highlighted") {
        bar.removeAttribute("id");
    } else {
        bar.id = "highlighted";
    }
};
/**
 * To change tooltip flag direction based on mouse position
 */
ToolTipMixin.prototype.changeToolTipDirection = function (obj) {

    var tooltip = this.get("tooltipInfo");

    var tooFarRight = obj.tooltip && obj.mouse[0] >= obj.canvasWidth - obj.tooltip.width; //Boolean for right canvas boundry
    var tooFarLeft = obj.tooltip && obj.mouse[0] < obj.canvasWidth - obj.tooltip.width; //Boolean for left canvas boundry
    var tooHigh = obj.tooltip && obj.mouse[1] <= obj.tooltip.height; //Boolean for top canvas boundry
    var tooLow = obj.tooltip && obj.mouse[1] >= obj.canvasHeight - obj.tooltip.height; //Boolean for bottom canvas boundry

    var windowHeight = window.innerHeight; // Window/viewport height to use for bottom boundry
    var viewportMousePositionY = d3.event.clientY; // Y mouse position relative to window/viewport
    var exceedsViewportTop = obj.tooltip && obj.tooltip.height - obj.mouse[1] > obj.canvasTop; //Boolean check if tooltip exceeds beyond viewport top
    var exceedsViewportBottom = obj.tooltip && viewportMousePositionY + obj.tooltip.height > windowHeight; //Boolean check if tooltip exceeds beyond viewport bottom

    // If flag exceeds top and bottom of canvas, then check collision with viewport viewport
    if (tooHigh && tooLow) {

        // Check collision to viewport, default to display flag down if conditions both fail
        tooHigh = !exceedsViewportTop && exceedsViewportBottom ? false : true;
        tooLow = !exceedsViewportTop && exceedsViewportBottom ? true : false;
    }

    // If flag exceeds neither the top or bottom of canvas default the position
    if (!tooHigh && !tooLow) {
        tooLow = true;
    }

    // Note: Direction styles for this chart corresponds to inverse positions, seemingly due to previous styles applied
    if (tooFarRight && tooLow) {

        tooltip.hide();
        this.set("tooltipHidden", true);
        this.set("direction", "left-bottom");
        return;
    }

    if (tooFarLeft && tooLow) {

        tooltip.hide();
        this.set("tooltipHidden", true);
        this.set("direction", "right-bottom");
        return;
    }

    if (tooFarRight && tooHigh) {

        tooltip.hide();
        this.set("tooltipHidden", true);
        this.set("direction", "left-top");
        return;
    }

    if (tooFarLeft && tooHigh) {

        tooltip.hide();
        this.set("tooltipHidden", true);
        this.set("direction", "right-top");
        return;
    }

    return;
};
/**
 * To display tooltip flag if enabled
 */
ToolTipMixin.prototype.renderToolTip = function () {
    var showToolTip = this.get("showToolTip");
    if (showToolTip) {
        this.drawToolTipCanvas();
    }

    if (showToolTip) {
        this.addToolTip({
            namespace: this.get("id")
        });
        this.set("direction", "top-right");
    }
};

module.exports = ToolTipMixin;

/***/ }),

/***/ 65:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Core = __webpack_require__(0);
var Utils = Core.Utils;
var Classes = Core.Classes;
var mbc_mds_chart_color = Utils.colors.mbc_mds_chart_color;

function VisualMods() {}
/**
* To set the text-anchor for each x-axis tick
*/
VisualMods.prototype.setTextAnchor = function (xAxisGroup, xAxisText) {

    xAxisGroup.attr("y", 4).attr("x", 0).style("text-anchor", "middle");

    xAxisText.first().style("text-anchor", "start");

    xAxisText.last().style("text-anchor", "end");
};
/**
* To change dashes for x-axis negative values into en-dashes
*/
VisualMods.prototype.useEnDash = function (xAxisText) {
    xAxisText.each(function () {
        var el = d3.select(this);
        var stringed = el.text();
        if (stringed.charAt(0) === "-") {
            var sliced = "\u2013" + stringed.slice(1);
            el.text(sliced);
        }
    });
};
/**
 * To add padding between tick text and axis, also to vertical tick lines
 */
VisualMods.prototype.addPadding = function (xAxisGroup, xAxisOrient, xAxisText) {

    if (xAxisOrient === "bottom") {
        xAxisText.attr("y", 1);
    }

    if (xAxisOrient === "top") {
        xAxisText.attr("y", 2);
    }

    var group = xAxisGroup.selectAll("g"),
        allLines = group.selectAll("line"),
        vlh = this.get("verticalLineHeight"),
        padding = this.get("barPadding");

    if (xAxisOrient === "bottom") {
        allLines.attr("y1", vlh - vlh - padding).attr("y2", vlh * -1);
    } else {
        allLines.attr("y2", vlh).attr("y1", vlh - vlh + padding);
    }
};
/**
 * To add the tick symbol to the first x-axis tick
 */
VisualMods.prototype.addTickTextSymbol = function (xAxisGroup, xAxisText) {

    var firstTickText = xAxisGroup.selectAll("text").first().text();
    var symbol = this.get("xAxisTextSymbol");

    xAxisText.first().text(function () {
        return firstTickText + symbol;
    });
};
/**
 * To remove vertical tick line from 0 tick value
 */
VisualMods.prototype.removeZeroTickLine = function (xAxisGroup) {
    xAxisGroup.selectAll("g text").each(function (d) {
        if (d === 0) {
            d3.select(this.parentNode).classed("zero-ticker", true);
        }
    });
};
/**
 * To remove x-axis horizontal rule
 */
VisualMods.prototype.removeHorizontalRule = function (xAxisGroup) {

    var path = xAxisGroup.select("path");
    path.attr("d", "");
};
/**
 * Check for responsive breakpoints & set # of ticks to display
 */
VisualMods.prototype.checkBreakpoints = function () {

    var canvas = this.get("canvas"),
        forceNegativeDomain = this.get("forceNegativeDomain"),
        domain = this.get("data").calculateDomain({
        forceNegative: forceNegativeDomain,
        roundTo: this.get("roundDomainTo"),
        integers: this.get("prettyTicks")
    }),
        tickNum;

    if (canvas.outerWidth() <= this.get("outerWidthBreakPoint")) {
        this.set("xAxisTickNumber", this.get("breakPointTickNumbers"));
        tickNum = this.get("xAxisTickNumber");
        this.set("xAxisTickValues", Utils.chart.getTickValues(domain, tickNum));
    } else {
        this.set("xAxisTickNumber", this.get("originalTickNumbers"));
        tickNum = this.get("xAxisTickNumber");
        this.set("xAxisTickValues", Utils.chart.getTickValues(domain, tickNum));
    }
};
/**
 * To separate chart and legend into different divs
 */
VisualMods.prototype.beforeCanvas = function () {
    var template = "<div class=\"" + Classes.LEGEND + "\"></div>\n            <div class=\"" + Classes.INNER + "\"></div>";

    this.set("canvasTemplate", template);
};
/**
 * To render all visual modification methods
 */
VisualMods.prototype.renderVisualMods = function () {

    var canvas = this.get("canvas");
    var xAxisGroup = canvas.get("svg").select(".mbc-axis.mbc-axis-x");
    var xAxisOrient = this.get("xAxisOrient");
    var xAxisText = xAxisGroup.selectAll("text");

    this.setTextAnchor(xAxisGroup, xAxisText);
    this.useEnDash(xAxisText);
    this.addPadding(xAxisGroup, xAxisOrient, xAxisText);
    this.addTickTextSymbol(xAxisGroup, xAxisText);
    this.removeHorizontalRule(xAxisGroup);

    if (!this.get("xAxisZeroTickLine")) {
        this.removeZeroTickLine(xAxisGroup);
    }
};

VisualMods.prototype.setBarPadding = function () {

    var height = this.get("canvas").height(),
        length = this.get("barInput").length,
        padding = Utils.chart.getBarPadding(length, height, "horizontal");

    this.set("barPadding", padding);
};

VisualMods.prototype.setBarColor = function () {
    if (!this.get("defaultBarColor")) {
        this.set("defaultBarColor", mbc_mds_chart_color["1"]);
    }
};

module.exports = VisualMods;

/***/ }),

/***/ 66:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var DataMethods = __webpack_require__(63);
var Legend = __webpack_require__(2);
var ToolTip = __webpack_require__(64);
var VisualMods = __webpack_require__(65);
var Core = __webpack_require__(0);
var Chart = Core.Chart;
var Utils = Core.Utils;
var Classes = Core.Classes;
var validateData = Utils.object.NaNtoNull;

/**
 * To create a horizontal bar chart class, an extension of the Chart Class
 *
 * @class
 * @extends Chart
 */
var HBC = Chart.extend(DataMethods, Legend, ToolTip, VisualMods,
/**
 *  @lends HBC
 **/
{
    // Default chart attributes
    id: "mbc-horizontal-bar-chart",
    /** @type {String} */
    xAxisOrient: "bottom",
    /** @type {Number} */
    xAxisOuterTickSize: 0,
    /** @type {Number} */
    xAxisTickNumber: 4,
    /** @type {Boolean} */
    xAxisZeroTickLine: true,
    /** @type {String} */
    xAxisTextSymbol: "%",
    /** @type {Array} */
    xAxisTickValues: null,
    /** @type {Object} */
    xAxisMinMaxIntervalValues: { // all 3 props required
        minXValue: null, // Pass a number to set the min x-axis value
        maxXValue: null, // Pass a number to set the max x-axis value
        xIntervals: null // Pass a number to set the value used as the x-axis interval between values.
    },
    /**
     * Either D3 format string, "none", or function
     * that takes data as an argument
     * @type {String|Function}
     */
    xAxisTickFormat: "none",
    /** @type {Number} */
    xAxisInnerTickSize: null,
    /** @type {String} */
    yAxisOrient: "left",
    /** @type {Number} */
    yAxisOuterTickSize: 0,
    /** @type {Number} */
    yAxisTickValues: 0,
    /** @type {Number} */
    yAxisTickPadding: 6,

    /** @type {Number} */
    barPadding: 9,
    /** @type {String} */
    defaultBarColor: null,
    /** @type {Number} */
    benchMarkWidth: 2,
    /** @type {Boolean} */
    benchMarksVisible: false,
    /**
     * Either D3 format value or "none"
     * @type {String}
     */
    yCoordinateFormat: null,
    /**
     * Either D3 format value or "none"
     * @type {String}
     */
    barHeightFormat: null,
    /** @type {Number} */
    customBarPadding: null,
    /**
     * To render chart with 0 x-axis in middle
     * @type {Boolean}
     */
    forceNegativeDomain: false,
    /** @type {Boolean} */
    dataChanged: false,
    /** @type {Boolean} */
    containerChanged: false,
    /** @type {Number} */
    outerWidthBreakPoint: 400,
    /** @type {Number} */
    breakPointTickNumbers: 2,
    /** @type {Number} */
    originalTickNumbers: 4,
    /** @type {Boolean} */
    showLegend: true,
    /** @type {String} */
    legendFundName: "Fund Name",
    /** @type {String} */
    legendBenchmarkName: "Benchmark",
    /** @type {Boolean} */
    legendCreated: false,
    /** @type {Boolean} */
    showToolTip: true,
    /** @type {Boolean} */
    toolTipUseStaticHeader: true,
    /** @type {String} */
    toolTipStaticHeader: "Title",
    /** @type {String} */
    toolTipDynamicHeaderPath: "name",
    /** @type {String} */
    toolTipLabel1: "Label",
    /** @type {String} */
    toolTipLabel2: "Benchmark",
    /**
     * Either D3 format string, "none", or function
     * that takes data as an argument
     * @type {String|Function}
     */
    toolTipTickFormat: "none",
    /** @type {Number} */
    roundDomainTo: null,
    /** @type {Boolean} */
    prettyTicks: true,
    /** @type {Boolean} */
    symmetrical: true,
    beforeDraw: function beforeDraw() {
        var legend = this.get("selection").select(".mbc-chart-legend");
        var child = legend[0][0].children;
        var arr = [].slice.call(child);
        if (typeof arr !== 'undefined') {
            arr.forEach(function (gElem) {
                gElem.parentElement.removeChild(gElem);
            });
        }

        if (this.get("customBarPadding")) {
            var barPadding = this.get("customBarPadding");
            this.set("barPadding", barPadding);
        } else {
            this.setBarPadding();
        }
        this.setBarColor();
    },
    /**
    * To render canvas, axes, horizontal bars and, optionally, benchmarks
    */
    draw: function draw() {

        if (this.get("showLegend")) {
            var legend = this.get("selection").select(".mbc-chart-legend").append('div').attr('class', Classes.LEGEND + "-container");
            var orient = this.get("xAxisOrient");
            this.invokeLegend({
                chart: 'horizontalBar',
                legend: legend,
                orient: orient
            });
        }

        this.buildScales();
        this.setScales();
        this.buildAxes();
        this.drawAxis();
        this.drawBars();

        if (this.get("benchMarksVisible") === true) {
            this.drawBenchMarks();
        }
    },
    /**
     * To apply post-chart-rendering changes
     */
    afterDraw: function afterDraw() {
        this.renderVisualMods();
        this.renderToolTip();

        if (this.get("showLegend")) {
            this.updateLegendFont(500);
        }
    },
    /**
     * This method is intended for legend to load and width recalculation.
     * Checks that custom 'MorningstarIntrisic' font is loaded by comparing string width
     * If Univers is loaded then ends no update required
     */
    updateLegendFont: function updateLegendFont(allowTime) {
        var _this = this;
        var legend = this.get("selection").select(".mbc-chart-legend");
        var orient = this.get("xAxisOrient");
        var mTimerCount = 0;
        var fontLoadedText = Utils.string.getTextWidth("legendFundName", '"MorningstarIntrisic", sans-serif', '14px');
        var notLoadedText = Utils.string.getTextWidth("legendFundName", 'sans-serif', '14px');
        if (fontLoadedText !== notLoadedText) return;
        var interval = setTimeout(function () {
            _this.invokeLegend({
                chart: 'horizontalBar',
                legend: legend,
                orient: orient
            });
            _this.update();
            return;
        }, 1, _this, legend, orient);
    },
    /**
    * To render horizontal bars
    */
    drawBars: function drawBars() {

        var _this = this,
            scales = this.get("scales"),
            canvas = this.get("canvas"),
            layer = canvas.layer("bar-chart-layer"),
            barInput = this.get("barInput"),
            xScale = scales.scale("x"),
            yFormat = this.get("yCoordinateFormat"),
            barHeightFormat = this.get("barHeightFormat"),
            barPadding = this.get("barPadding"),
            barData = this.get("data").get("barData")[0].series,
            barColor = this.get("defaultBarColor"),
            length = barData.length,
            barSpacing = canvas.height() / length - barPadding / length,
            barHeight = typeof barHeightFormat === "function" ? barHeightFormat(barSpacing - barPadding) : barSpacing - barPadding;

        this.set("verticalLineHeight", barSpacing * length);

        var bars = layer.selectAll("rect").data(barInput);

        bars.enter().append("rect").attr("transform", "translate(0,0 )").attr("y", function (d, i) {
            return typeof yFormat === "function" ? yFormat(i * barSpacing + barPadding) : i * barSpacing + barPadding;
        }).attr("height", barHeight).attr("x", function (d) {
            return xScale(Math.min(0, validateData(_this.getSingleBarData(d))));
        }).attr("width", function (d) {
            return Math.abs(xScale(validateData(_this.getSingleBarData(d))) - xScale(0));
        }).attr("class", "h-bar").attr("fill", function (d, i) {
            var ibar = barInput[i];
            return ibar.color || barColor;
        });

        bars.transition().duration(300).attr("transform", "translate(0,0 )").attr("y", function (d, i) {
            return typeof yFormat === "function" ? yFormat(i * barSpacing + barPadding) : i * barSpacing + barPadding;
        }).attr("height", barHeight).attr("x", function (d) {
            return xScale(Math.min(0, validateData(_this.getSingleBarData(d))));
        }).attr("width", function (d) {
            return Math.abs(xScale(validateData(_this.getSingleBarData(d))) - xScale(0));
        }).attr("fill", function (d, i) {
            var ibar = barInput[i];
            return ibar.color || barColor;
        });

        bars.exit().remove();
    },
    /**
    * To add x and y axes, ticks to canvas
    */
    drawAxis: function drawAxis() {
        var axes = this.get("axes");
        var canvas = this.get("canvas");
        canvas.drawAxes(axes);
    },
    /**
    * To configure x and y axes
    */
    buildAxes: function buildAxes() {

        this.checkBreakpoints();

        var scales = this.get("scales");
        var height = this.get("canvas").height();
        var axes = this.get("axes");
        var xAxisOrient = this.get("xAxisOrient");
        var xAxisOuterTickSize = this.get("xAxisOuterTickSize");
        var tickFormat = this.get("xAxisTickFormat");
        var xIntervals = this.get("xAxisMinMaxIntervalValues").xIntervals;
        var xDomain = this.getDomain();

        if (xIntervals !== null) {
            this.set("xAxisTickValues", d3.range(xDomain[0], xDomain[1] + 10, xIntervals));
        }

        this.set("xAxisInnerTickSize", height * -1);

        var xAxis = d3.svg.axis().scale(scales.scale("x")).orient(xAxisOrient).innerTickSize(this.get("xAxisInnerTickSize")).outerTickSize(xAxisOuterTickSize).tickValues(this.get("xAxisTickValues")).ticks(this.get("xAxisTickNumber")).tickFormat(function (d, i) {
            return typeof tickFormat === "function" ? tickFormat(d, i) : d3.format(tickFormat)(d);
        });

        var yAxis = d3.svg.axis().scale(scales.scale("y")).orient(this.get("yAxisOrient")).outerTickSize(this.get("yAxisOuterTickSize")).tickValues(this.get("yAxisTickValues")).tickPadding(this.get("yAxisTickPadding"));

        axes.axis("x", xAxis);
        axes.axis("y", yAxis);
    },
    /**
    * To configure the x and y scales
    */
    buildScales: function buildScales() {

        var scales = this.get("scales");
        var canvas = this.get("canvas");
        var xScale = d3.scale.linear().range([0, canvas.width()]);
        var yScale = d3.scale.ordinal().rangeRoundBands([0, canvas.height()], 0);

        scales.scale("x", xScale);
        scales.scale("y", yScale);
    },
    /**
    * To get the domain min and max value
    */
    getDomain: function getDomain() {
        var forceNegativeDomain = this.get("forceNegativeDomain");
        var minXValue = this.get("xAxisMinMaxIntervalValues").minXValue;
        var maxXValue = this.get("xAxisMinMaxIntervalValues").maxXValue;
        var domain;

        if ((minXValue && maxXValue) !== null) {
            domain = [minXValue, maxXValue];
        } else {
            domain = this.get("data").calculateDomain({
                forceNegative: forceNegativeDomain,
                roundTo: this.get("roundDomainTo"),
                integers: this.get("prettyTicks"),
                symmetrical: this.get("symmetrical")
            });
        }

        return domain;
    },
    /**
    * To set the scales based on the domain
    */
    setScales: function setScales() {
        var scales = this.get("scales");
        var domain = this.getDomain();

        if (this.get("dataChanged")) {
            this.setScaleData(true);
        }

        scales.scale("x").domain(domain);

        scales.scale("y").domain([0, this.get("dataLength")]);
    },
    /**
     * To render benchmarks
     */
    drawBenchMarks: function drawBenchMarks() {

        var _this = this,
            benchData = this.get("data").get("benchMarkData")[0].series,
            length = benchData.length,
            benchMarkInput = this.get("benchMarkInput"),
            scales = this.get("scales"),
            canvas = this.get("canvas"),
            layer = canvas.layer("benchmark-layer"),
            xScale = scales.scale("x"),
            yFormat = this.get("yCoordinateFormat"),
            barPadding = this.get("barPadding"),
            barSpacing = canvas.height() / length - barPadding / length,
            barHeightFormat = this.get("barHeightFormat"),
            canvasWidth = canvas.width(),
            benchMarkWidth = this.get("benchMarkWidth"),
            barHeight = typeof barHeightFormat === "function" ? barHeightFormat(barSpacing - barPadding) : barSpacing - barPadding;

        var marks = layer.selectAll(".benchmark").data(benchMarkInput);

        marks.exit().remove();

        marks.enter().append("rect").classed("benchmark", true).attr("transform", "translate(0, 0" + ")").attr("y", function (d, i) {
            return typeof yFormat === "function" ? yFormat(i * barSpacing + barPadding) : i * barSpacing + barPadding;
        }).attr("height", barHeight).attr("x", function (d) {
            var xScaleD = xScale(validateData(_this.getSingleBenchMarkData(d)));
            return Math.min(canvasWidth - benchMarkWidth, xScaleD);
        }).attr("width", function (d) {
            if (validateData(_this.getSingleBarData(d)) === null) {
                return 0;
            } else {
                return benchMarkWidth;
            }
        });

        marks.transition().duration(300).attr("transform", "translate(0, 0" + ")").attr("y", function (d, i) {
            return typeof yFormat === "function" ? yFormat(i * barSpacing + barPadding) : i * barSpacing + barPadding;
        }).attr("height", barHeight).attr("x", function (d) {
            var xScaleD = xScale(validateData(_this.getSingleBenchMarkData(d)));
            return Math.min(canvasWidth - benchMarkWidth, xScaleD);
        }).attr("width", function (d) {
            if (validateData(_this.getSingleBarData(d)) === null) {
                return 0;
            } else {
                return benchMarkWidth;
            }
        });
    },
    /**
    * To remove benchmarks from chart
    */
    removeBench: function removeBench() {
        var layer = this.get("canvas").get("chartGroup");
        var marks = layer.selectAll(".benchmark");

        if (this.get("benchMarksVisible") === true) {
            this.set("benchMarksVisible", false);
            this.set("benchMarkInput", null);
            this.get("data").update("benchMarkData", []);

            // Remove benchmarks
            marks.remove();

            // Remove benchmarks legend
            var legend = this.get("selection").select(".mbc-chart-legend");
            legend.select(".benchmark-legend").remove();
        }
    }
});

module.exports = HBC;

/***/ })

/******/ });
});